new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_header',
    data: {
        header: {
          useFirst: true, // first headerBar
          myaccount_options: 'dropdown', // 'none' = no dropdowns, 'dropdown' = hover and dropdown menu;
          isNavUp: true,
          isNavDown: true,
          isNavMin: false,
          lastScrollTop: 0,
          menuMobile: false,
          openCategorysMobile: false,
        },
        searchOpened: false,
        cartOpened: false,
    },
    methods: {
      addPaddingHeader() {
        const screenWidth = window.innerWidth;
          const header = document.querySelector('header[data-role="heading"]');
          const headerHeight = header.clientHeight;
          const mainTag = document.querySelector('main[role="main"]');
          const bread = document.querySelector('.breadcrumb');
          const mainDiv = document.querySelector('.main-content');
        
          if (mainTag) {
            mainTag.style.paddingTop = `${headerHeight}px`;
          } else if (mainDiv && bread) {
            if (getComputedStyle(bread).display === 'none') {
              mainDiv.style.paddingTop = `${headerHeight}px`;
            } else {
              mainDiv.style.paddingTop = '0px';
              bread.style.marginTop = `${headerHeight}px`;
            }
          } else if (mainDiv) {
            mainDiv.style.paddingTop = `${headerHeight}px`;
          } else if (bread) {
            bread.style.marginTop = `${headerHeight}px`;
          }
      },

      runSpeechRecognition() {
        var isChromium = window.chrome;
        var winNav = window.navigator;
        var vendorName = winNav.vendor;
        var isOpera = typeof window.opr !== "undefined";
        var isIEedge = winNav.userAgent.indexOf("Edge") > -1;
        var isIOSChrome = winNav.userAgent.match("CriOS");

        if(isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc." && isOpera === false && isIEedge === false) {
          let output = document.querySelector(".output-search");
          let action = document.querySelector(".microphone");
          let inputMic = document.querySelector(".search__text");
      
          var SpeechRecognition = SpeechRecognition || webkitSpeechRecognition;
  
          var recognition = new SpeechRecognition();
          recognition.continuous = false;
          recognition.lang = 'pt-BR';
  
      
          recognition.onstart = function() {
          if (!output.classList.contains("hide")) {
              output.classList.toggle("hide");
          }   
          
          action.classList.toggle('active');
          };
          
          recognition.onspeechend = function() {
          
          action.classList.toggle('active');
              recognition.stop();
          }
      
          recognition.onresult = function(event) {
              var transcript = event.results[0][0].transcript;
              var confidence = event.results[0][0].confidence * 100;
          
              if(confidence < 50) {
                  inputMic.classList.toggle('not-understand')
                  output.classList.toggle("hide");
                  inputMic.value = "Desculpe não entendi muito bem.";
              } else {
                  inputMic.value = transcript
                  document.querySelector('.search__submit').click()
              };
              
          };
      
          // start recognition
          recognition.start();
        } else return document.querySelector(".microphone-search").remove();
      },
      handleScroll() {
          const st = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
          const scrollDifference = st - this.lastScrollTop;
          const customMobile = document.getElementById('custom-mobile-nav');
          const headerThird = document.getElementById('header-third');
          const quickMenu = document.getElementById('quick-menu-id');
          const whatsappWidget = document.getElementById('widget-whatsapp');

          if (st > this.lastScrollTop)
              this.header.isNavUp = false;
          else {
              if (st === 0) 
                this.header.isNavUp = true;
          }

          if (st >= 90 && scrollDifference > 0) {
            this.header.isNavDown     = false;
            this.header.isNavMin      = true;

            if (customMobile)
              customMobile.classList.add('hide');

            if (headerThird)
              headerThird.classList.add('hide');

            if (quickMenu) {
              quickMenu.classList.add('hide');
              whatsappWidget.style.bottom = '';
            }

          } else {
            this.header.isNavDown     = true;
            this.header.isNavMin      = false;
            this.header.isNavMenuHide = false;

            if (customMobile)
              customMobile.classList.remove('hide');

            if (headerThird)
              headerThird.classList.remove('hide');

            if (quickMenu) {
              quickMenu.classList.remove('hide');
              whatsappWidget.style.bottom = '79px';
            }
          }

          this.lastScrollTop = st;
      },
      filterItems(item1, item2, item3, item4) {
        var data = [item1, item2, item3, item4];

        for (var i = 0; i < data.length; i++) {
          var element = document.querySelector('[item="' + data[i] + '"]');
          switch (data[i]) {
            case "home":
                element.setAttribute('href', '/');
                break;
            case "menu":
                var newSpan = document.createElement('span');
                newSpan.setAttribute('class', 'quick-menu__item--link toggleMenu js-mobile-nav-trigger');

                while (element.firstChild) {
                  newSpan.appendChild(element.firstChild);
                }

                element.parentNode.replaceChild(newSpan, element);
                break;
            case "cart":
                element.setAttribute('href', '/carrinho');
                break;
            case "user":
                element.setAttribute('href', '/clientes/identificacao/?next=/clientes/minha-conta/');
                break;
            case "wishlist":
                element.setAttribute('href', '/clientes/minha-conta/minha-lista-de-produtos/');
                break;
          }
        }
      }
    },
    mounted() {
      this.addPaddingHeader();

      const stopwatchElement = document.querySelector('.stopwatch');

    if (stopwatchElement) {
      const urlParametro = stopwatchElement.getAttribute('data-url') ? stopwatchElement.getAttribute('data-url').trim() : "";
      const hora = parseInt(stopwatchElement.getAttribute('data-hour'));
      const dia = parseInt(stopwatchElement.getAttribute('data-day'));
      const mes = parseInt(stopwatchElement.getAttribute('data-month'));
      const ano = parseInt(stopwatchElement.getAttribute('data-year'));

      if (!isNaN(hora) && !isNaN(dia) && !isNaN(mes) && !isNaN(ano)) {
        const urlAtual = window.location.pathname;
        let dataTermino;
        let cronometro;

        function atualizarCronometro() {
          const agora = new Date().getTime();
          const termino = dataTermino.getTime();
          const tempoRestante = termino - agora;

          if (tempoRestante >= 0) {
            const dias = Math.floor(tempoRestante / (1000 * 60 * 60 * 24));
            const horas = Math.floor((tempoRestante % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutos = Math.floor((tempoRestante % (1000 * 60 * 60)) / (1000 * 60));
            const segundos = Math.floor((tempoRestante % (1000 * 60)) / 1000);

            function formatarDigitos(numero) {
              const numeroFormatado = numero.toString().padStart(2, '0');
              return `<span>${numeroFormatado[0]}</span><span>${numeroFormatado[1]}</span>`;
            }

            const diasFormatado = formatarDigitos(dias);
            const horasFormatado = formatarDigitos(horas);
            const minutosFormatado = formatarDigitos(minutos);
            const segundosFormatado = formatarDigitos(segundos);

            document.getElementById("cronometro").innerHTML = `<p>Termina em </p> <div>${diasFormatado}d ${horasFormatado}h ${minutosFormatado}m ${segundosFormatado}s</div>`;
          } else {
            document.getElementById("cronometro").innerHTML = "Tempo esgotado!";
            clearInterval(cronometro);
          }
        }

        function aplicarPaddingTop() {
          const header = document.querySelector('header[data-role="heading"]');
          const cronometroBox = document.querySelector('.stopwatch #cronometro');
          const mainTag = document.querySelector('main[role="main"]');
          const mainDiv = document.querySelector('.main-content');

          if (!header) return;

          let totalHeight = header.clientHeight;

          if (cronometroBox) {
            totalHeight += cronometroBox.clientHeight;
          }

          if (mainTag) {
            mainTag.style.paddingTop = `${totalHeight}px`;
          } else if (mainDiv) {
            mainDiv.style.paddingTop = `${totalHeight}px`;
          }
        }

        function mostrarCronometro() {
          dataTermino = new Date(ano, mes - 1, dia, hora, 0);
          cronometro = setInterval(atualizarCronometro, 1000);

          // Espera o cronômetro renderizar um pouco para pegar altura real
          setTimeout(() => {
            aplicarPaddingTop();
          }, 100); // 100ms geralmente é o suficiente
        }

        if (urlParametro === "" || urlAtual.includes(urlParametro)) {
          mostrarCronometro();
        } else {
          stopwatchElement.style.display = 'none';
        }
      } else {
        console.error('Os atributos data-hour, data-day, data-month ou data-year estão ausentes ou inválidos.');
      }
    }

      let item1, item2, item3, item4

      if(document.getElementById('quick-item-1')) {
        item1 = document.getElementById('quick-item-1').getAttribute('item');
      }
      if(document.getElementById('quick-item-2')) {
        item2 = document.getElementById('quick-item-2').getAttribute('item');
      }
      if(document.getElementById('quick-item-3')) {
        item3 = document.getElementById('quick-item-3').getAttribute('item');
      }
      if(document.getElementById('quick-item-4')) {
        item4 = document.getElementById('quick-item-4').getAttribute('item');
      }
      
      if(item1 && item2 && item3 && item4) {
        this.filterItems(item1, item2, item3, item4);
      }
    },
    beforeDestroy() {
      //window.removeEventListener('scroll', this.handleScroll);
    },
    watch: {
      cartOpened(newValue) {
        if (newValue) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.removeProperty('overflow');
        }
      },

      searchOpened(newValue) {
        if (newValue) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.removeProperty('overflow');
        }
      },
    }
})

var cart_preview_triggers = $('.header__second--tools-cart, .cart-preview-header__close, .cart-preview--overlay, .cart-preview .btn-continue');

cart_preview_triggers.on("click", function (e) {
  $('.header__second--tools-cart-preview').toggleClass('active');
  document.body.classList.toggle('no-scroll');
  document.documentElement.classList.toggle('no-scroll');
});

$("#js-texto-header").slick({
  dots: false,
  arrows: false,
  infinite: true,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500,
  fade: true,
  cssEase: 'linear',
  autoplaySpeed: 2000,
});